// LabelWorkflowTable.tsx
import React from 'react';
import { useProjectDetailsContext } from '../contexts/ProjectDetailsContext';
import Avatar from './Avatar';
import LabelWorkflowTableRow from './LabelWorflowTableRow';
import '../styles/components/LabelWorkflowTable.scss';

const LabelWorkflowTable: React.FC = () => {
    const {
        state: { labels, userDetailsMapping, labelThumbnailUrls, project },
    } = useProjectDetailsContext();

    if (!project) return null;

    return (
        <div className="table-container margin-top-16">
            {labels.length > 0 ? (
                <table className="workflow-table">
                    <thead>
                        <tr>
                            <th></th>
                            <th>Version</th>
                            <th>Uploaded By</th>
                            <th>Date</th>
                            <th className="stage-header ai-stage-header">
                                <div className="stage-block-wrapper">
                                    <div className="stage-header-content">
                                        <span>AI Review</span>
                                    </div>
                                    <div className="stage-connector"></div>
                                </div>
                            </th>
                            {project.workflow.stages.map((stage: any, i: number) => (
                                <th 
                                    key={i} 
                                    className={`stage-header ${i === project.workflow.stages.length - 1 ? 'last-stage-header' : ''}`}
                                >
                                    <div className="stage-block-wrapper">
                                        <div className="stage-header-content">
                                            <span>{stage.name}</span>
                                            <Avatar
                                                userDetails={userDetailsMapping[stage.reviewer]}
                                                height={20}
                                            />
                                        </div>
                                        {i < project.workflow.stages.length - 1 && (
                                            <div className="stage-connector"></div>
                                        )}
                                    </div>
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {labels.map((label) => (
                            <LabelWorkflowTableRow
                                key={label.id}
                                label={label}
                                labelThumbnailUrl={labelThumbnailUrls[label.id]}
                                userDetailsMapping={userDetailsMapping}
                                project={project}
                            />
                        ))}
                    </tbody>
                </table>
            ) : (
                <p className="no-results-message">No labels uploaded yet.</p>
            )}
        </div>
    );
};

export default LabelWorkflowTable;
